<template>
  <main
      v-if="client"
      class="py-10">
    <!-- Page header -->
    <div
        class="max-w-3xl mx-auto px-4 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-8">
      <div
          class="flex items-center space-x-5">
        <div
            class="flex-shrink-0">
          <div
              class="relative">
            <img
                v-if="client.image"
                class="h-16 w-16 rounded-full"
                :src="client.image"
                alt=""/>
            <span
                class="absolute inset-0 shadow-inner rounded-full"
                aria-hidden="true"/>
          </div>
        </div>
        <div>
          <div class="flex flex-row gap-2">
            <button
                @click="() => focusField('name')"
                class="p-1 bg-brand-dark hover:opacity-75 text-white rounded-full ">
              <PencilIcon class="h-4 w-6" />
            </button>
            <h1
                v-show="!showField('name')"
                class="text-2xl font-bold text-gray-900">
              {{ client.name }}
            </h1>
            <input
                id="name"
                ref="name"
                v-model="client.name"
                v-show="showField('name')"
                type="text"
                @blur="blurField"
                @input="v$.client.name.$touch"
                class="text-2xl px-2 py-0 font-bold text-gray-800">
          </div>
          <p
              class="text-sm font-medium text-gray-500">
            On the Gravy Train since
            <time :datetime=client.createdAt>{{ $filters.formatDate(client.createdAt) }}</time>
          </p>
        </div>
      </div>
      <div
          class="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end
                  sm:space-x-reverse sm:space-y-0 sm:space-x-3 md:mt-0 md:flex-row md:space-x-3">
        <is-manager>
          <primary-button
              :disabled="!v$.client.name.$dirty"
              type="button"
              @click="updateClient()"
              text="Update" />
        </is-manager>


      </div>
    </div>

    <div
        class="mt-8 max-w-3xl mx-auto grid grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-1">
      <div
          class="space-y-6 lg:col-start-1 lg:col-span-2">
        <!-- Description list-->
        <is-contributor>
          <section
              aria-labelledby="applicant-information-title">
            <div
                class="bg-white shadow sm:rounded-lg">
              <div
                  class="px-4 py-5 sm:px-6">
                <h2
                    id="applicant-information-title"
                    class="text-lg leading-6 font-medium text-gray-900">
                  Client Information
                </h2>
              </div>
              <div
                  class="border-t border-gray-200 px-4 py-5 sm:px-6">
                <dl
                    class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                  <create-email-setting-panel/>
                  <update-email-setting-panel/>
                  <div
                      class="sm:col-span-2">
                    <dt
                        class="text-sm font-medium text-gray-500">
                      Email Settings
                    </dt>
                    <dd
                        class="mt-1 text-sm text-gray-900">
                      <div
                          class="px-4 py-6 sm:px-6">
                        <email-settings-table
                            :emailSettings="emailSettings"
                            :client-id="client.id"/>
                      </div>
                    </dd>
                    <is-manager>
                      <button
                          @click.prevent="openCreateEmailSettingPanel"
                          type="button"
                          class="mt-3 inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm
                             font-medium rounded-md shadow-sm text-white bg-brand-primary hover:opacity-75 focus:outline-none
                             focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500">
                        Create Email Setting
                      </button>
                    </is-manager>

                  </div>

                </dl>
              </div>
              <div>
              </div>
            </div>
          </section>
        </is-contributor>

        <section
            aria-labelledby="notes-title">
          <div
              class="bg-white shadow sm:rounded-lg sm:overflow-hidden">
            <div
                class="divide-y divide-gray-200">
              <div
                  class="px-4 py-5 sm:px-6">
                <h2
                    id="products-title"
                    class="text-lg font-medium text-gray-900">
                  Products
                </h2>
              </div>
              <create-product-panel/>
              <update-product-panel/>
              <create-template-panel
                  :client-id="client.id"/>
              <div
                  v-if="products"
                  class="px-4 py-6 sm:px-6">
                <products-table
                    :products="products"
                    :client-id="client.id"/>
              </div>
            </div>
            <div
                class="bg-gray-50 px-4 py-6 sm:px-6">
              <button
                  @click.prevent="openCreateProductsPanel"
                  type="button"
                  class="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium
                  rounded-md shadow-sm text-white bg-brand-primary hover:opacity-75 focus:outline-none focus:ring-2
                  focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-blue-500">
                Create Product
              </button>
            </div>
          </div>
        </section>

        <section
            aria-labelledby="notes-title">
          <div
              class="bg-white shadow sm:rounded-lg sm:overflow-hidden">
            <div
                class="divide-y divide-gray-200">
              <div
                  class="px-4 py-5 sm:px-6">
                <h2
                    id="templates-title"
                    class="text-lg font-medium text-gray-900">
                  Email Templates
                </h2>
              </div>

              <div
                  v-if="templates"
                  class="px-4 py-6 sm:px-6">
                <templates-table
                    :templates="templates"
                    :client-id="client.id"
                    :edit-callback="setActiveTemplate"/>
              </div>
            </div>
            <div
                class="bg-gray-50 px-4 py-6 sm:px-6">
              <primary-button
                  text="Create Template"
                  @click="openCreateTemplatePanel"
                  type="button" />
            </div>
          </div>
        </section>
      </div>
    </div>

  </main>
</template>

<script>
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Popover,
  PopoverButton,
  PopoverOverlay,
  PopoverPanel,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import {
  ArrowNarrowLeftIcon,
  CheckIcon,
  HomeIcon,
  PaperClipIcon,
  QuestionMarkCircleIcon,
  SearchIcon,
  ThumbUpIcon,
  UserIcon,
} from '@heroicons/vue/solid'
import {BellIcon, MenuIcon, XIcon, PencilIcon} from '@heroicons/vue/outline'
import EmailSettingsTable from "@/components/ClientDetails/EmailSettingsTable";
import ProductsTable from "@/components/ClientDetails/ProductsTable";
import TemplatesTable from "@/components/ClientDetails/TemplatesTable";
import UsersTable from "@/components/ClientDetails/UsersTable";
import CreateProductPanel from "@/components/ClientDetails/SlideoutPanels/CreateProductPanel";
import UpdateProductPanel from "@/components/ClientDetails/SlideoutPanels/UpdateProductPanel";
import CreateTemplatePanel from "@/components/ClientDetails/SlideoutPanels/CreateTemplatePanel";
import CreateEmailSettingPanel from "@/components/ClientDetails/SlideoutPanels/CreateEmailSettingPanel";
import UpdateEmailSettingPanel from "@/components/ClientDetails/SlideoutPanels/UpdateEmailSettingPanel";
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import IsManager from "@/components/Authorization/IsManager";
import IsContributor from "@/components/Authorization/IsContributor";
import useVuelidate from "@vuelidate/core";

export default {
  name: "ClientDetail",

  data() {
    return {
      activeTemplate: false,
      createProductMode: false,
      editField: '',
      errors: [],
      attachments: [],
      dirty:true,
      v$: useVuelidate()
    }
  },
  unmounted() {
    this.$store.dispatch('resetTemplates')
    this.$store.dispatch('resetProducts')
    this.$store.dispatch('resetEmailSettings')
  },
  async mounted() {
    this.$store.dispatch('showLoadingSpinner')
    await this.getClient()
    try {
      await this.$store.dispatch('getProducts', this.$route.params.id)
    } catch (e) {
      this.errors.push(e);
      this.$store.dispatch('createAlert', {
        type: 'danger',
        message: e
      })
    }
    try {
      await this.$store.dispatch('getTemplates', this.$route.params.id)
    } catch (e) {
      this.errors.push(e);
      this.$store.dispatch('createAlert', {
        type: 'danger',
        message: e
      })
    }
    try {
      await this.$store.dispatch('getEmailSettings', this.$route.params.id)
    } catch (e) {
      this.errors.push(e)
      this.$store.dispatch('createAlert', {
        type: 'danger',
        message: e
      })
    }
    this.$store.dispatch('hideLoadingSpinner')

    // this.client.id = parseInt(this.$route.params.id)
  },
  methods: {
    async getClient() {
      try {
        await this.$store.dispatch('getClient', this.$route.params.id)
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
    },
    async updateClient() {
      this.$store.dispatch('showLoadingSpinner')

      try {
       await this.$store.dispatch('updateClient', this.client)

       this.$store.dispatch('createAlert', {
         type: 'success',
         message: 'Client Successfully Updated'
       })
     }  catch (e) {
       this.$store.dispatch('createAlert', {
         type: 'danger',
         message: e
       })
       await this.getClient()
     }
     this.v$.client.name.$dirty = false
      this.$store.dispatch('hideLoadingSpinner')

    },
    setActiveTemplate(template = null) {
      this.activeTemplate = template
    },
    openCreateEmailSettingPanel() {
      this.$store.dispatch('openCreateEmailSettingPanel')
    },
    openCreateProductsPanel() {
      this.$store.dispatch('openCreateProductPanel')
    },
    openCreateTemplatePanel() {
      this.$store.dispatch('openCreateTemplatePanel')
    },
    showField(name) {
      return this.editField === name;
    },
    focusField(name) {
      if (this.userRole === 'Contributor')  { return }
      this.editField = name
      this.dirty = false;
      this.$nextTick(() => {
        this.$refs.name.focus();
      })
    },
    blurField(client) {
      this.editField = '';
    }
  },
  validations: {
   client: {
     name: {}
   }
  },
  computed: {
    client() {
      return this.$store.getters.getClient
    },

    createTemplatePanelIsOpen() {
      return this.$store.getters.getCreateTemplatePanelIsOpen
    },
    emailSettings() {
      return this.$store.getters.getEmailSettings
    },
    updateProductPanelIsOpen() {
      return this.$store.getters.getUpdateProductPanelIsOpen
    },
    products() {
      return this.$store.getters.getProducts
    },
    templates() {
      return this.$store.getters.getTemplates
    },
    userRole() {
      return this.$store.getters.getGravyUserRole
    }
  },
  components: {
    IsContributor,
    IsManager,
    PrimaryButton,
    CreateTemplatePanel,
    UpdateEmailSettingPanel,
    CreateEmailSettingPanel,
    UpdateProductPanel,
    CreateProductPanel,
    UsersTable,
    TemplatesTable,
    EmailSettingsTable,
    ProductsTable,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Popover,
    PopoverButton,
    PopoverOverlay,
    PopoverPanel,
    TransitionChild,
    TransitionRoot,
    ArrowNarrowLeftIcon,
    BellIcon,
    HomeIcon,
    MenuIcon,
    PaperClipIcon,
    PencilIcon,
    QuestionMarkCircleIcon,
    SearchIcon,
    XIcon,
  }
}


</script>

<style scoped>

</style>
